import type { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import FormControl, { type FormControlProps } from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import type { JSX } from 'react';
import { Checkbox } from '../Checkbox/Checkbox.tsx';

export type CheckboxProps = Partial<MuiCheckboxProps> & {
  'data-test'?: string;
  label?: string;
  message?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  margin?: FormControlProps['margin'];
};

export function CheckboxField(props: CheckboxProps): JSX.Element {
  const { message, label, error, 'data-test': dataTest, fullWidth, margin: _margin, ...withoutCustomProps } = props;

  return (
    <FormControl error={error} data-test={dataTest} fullWidth={fullWidth}>
      <FormControlLabel control={<Checkbox {...withoutCustomProps} />} label={label || ''} />
      {message && <FormHelperText>{message}</FormHelperText>}
    </FormControl>
  );
}
